import type { User } from '@/types/users.types';

/** The account signs in with a platform password (not OAuth / SAML / LDAP). */
export const signsInWithPassword = (user: Pick<User, 'loginmethod'> | null | undefined): boolean =>
  !!user && String(user.loginmethod ?? 'manual').toLowerCase() === 'manual';

/** An administrator asked this person to choose a new password before going on. */
export const mustChangePassword = (user: Pick<User, 'loginmethod' | 'force_password_change'> | null | undefined): boolean =>
  !!user?.force_password_change && signsInWithPassword(user);

export const CHANGE_PASSWORD_PATH = '/change-password';
